<template>
  <q-dialog
    v-model="showDialog"
    maximized
  >
    <q-card>
      <div class="row q-ma-sm items-center q-gutter-sm">
        <div
          class="col row justify-start items-center"
          style="flex-grow: 1"
        />
        <div class="col-auto text-h6">
          Select Tab To Merge
        </div>
        <div
          class="col row justify-end"
          style="flex-grow: 1"
        >
          <q-btn
            icon="close"
            flat
            round
            dense
            @click="showDialog = false"
          />
        </div>
      </div>
      <order-table
        ref="openTabDialog"
        initial-state="open_tab"
        :order-to-exclude="order.id"
        :show-controls="false"
        @edit="order => { merge(order)}"
        @select-order="order => merge(order)"
        @request-authorization="callback => $emit('request-authorization', callback)"
      />
    </q-card>
    <action-dialog
      ref="confirmMergeTabDialog"
      title="Confirm Tab Merge"
      ok-label="Confirm"
      cancel-label="Cancel"
      @ok="mergeTabOrder(selectedOrder)"
    />
  </q-dialog>
</template>

<script>
import ActionDialog from 'src/modules/consumer/components/ActionDialog'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'OpenTabMergeDialog',
  components: {
    OrderTable: defineAsyncComponent(() => import('src/modules/admin/order/OrderTable')),
    ActionDialog
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  emits: ['request-authorization', 'merge-order'],
  data () {
    return {
      showDialog: false,
      selectedOrder: null
    }
  },
  methods: {
    async mergeTabOrder () {
      this.$emit('merge-order', this.selectedOrder)
      this.selectedOrder = null
      this.showDialog = false
    },
    merge (order) {
      this.selectedOrder = order
      this.$refs.confirmMergeTabDialog.show()
    },
    show () {
      this.showDialog = true
    }
  }
}

</script>
